import { LiftInterface } from "../interfaces/Lift.interface";
import { LiftType } from "../flatbuffers/generated/archive/lift-type";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_LIFT: LiftInterface = {
  id: null,
  bankId: null,
  organizationId: null,
  name: "",
  type: LiftType.ELEVATOR,
  position: 0,
  questId: 0,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
  liftFloors: [
    {
      id: "",
      bankFloorId: "",
      liftId: "",
      frontDoor: false,
      rearDoor: false,
    },
  ],
};
